import crypto from 'crypto';

export const getSubmitSecretKey = () => {
    const nonces = [...document.querySelectorAll('script')].map(s => s.nonce).filter(s => s);
    return nonces[0];
}

export const getMD5Signature = (data, secretKey = getSubmitSecretKey()) => {
    const signature = crypto.createHash('md5').update(JSON.stringify(data) + secretKey).digest('hex');
    return signature;
}
